import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_REPORT_LIST, APP_FILE_REPORTS } from "./Reports.constants";

const Reports = Loadable(
  lazy(() =>
    import("./Reports").then(({ Reports }) => ({
      default: Reports,
    }))
  )
);
const ReportsView = Loadable(
  lazy(() =>
    import("./ViewReportHistory").then(
      ({ ViewReportsHistory }) => ({
        default: ViewReportsHistory,
      })
    )
  )
);
const ReportList = Loadable(
  lazy(() =>
    import("./ReportHistory").then(
      ({ AccountingReportsHistory }) => ({
        default: AccountingReportsHistory,
      })
    )
  )
);

export const ReportsRoutes = [
  {
              path: `${APP_FILE_REPORT_LIST}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
                  <ReportList />
                </AuthorizedRoute>
              ),
            },
            {
                    path: `${APP_FILE_REPORTS}`,
                    exact: true,
                    element: (
                      <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                        <Reports />
                      </AuthorizedRoute>
                    ),
                  },
                  {
                    path: `${APP_FILE_REPORTS}/:reportCode`,
                    exact: true,
                    element: (
                      <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                        <ReportsView />
                      </AuthorizedRoute>
                    ),
                  },
];
